/**
 * Error500 — Branded 500 Internal Server Error page (#2454)
 *
 * No ConfigProvider / AuthProvider / BrandProvider dependency.
 */

import { PAGE_CSS, Logo, ErrorCard } from "./shared";

export function Error500() {
  return (
    <>
      <style>{PAGE_CSS}</style>
      <div className="err-page">
        <ErrorCard
          code="500"
          title="Something went wrong"
          message="An unexpected error occurred on our end. Our team has been notified. Try refreshing — most issues resolve in seconds."
          accentVar="--brand-status-error"
          accentBg="var(--brand-status-error-bg)"
          accentBorder="rgba(201,64,64,0.25)"
          showRetry
        >
          <Logo />
        </ErrorCard>
      </div>
    </>
  );
}
